"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.consumerReducerFunction = exports.consumerActions = exports.consumerState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
exports.initialState = {
    data: null,
    errorMessage: null,
    loading: false,
    loaded: false,
    updateInfoResult: "none",
    updatePhoneNewsLetter: {
        loading: false,
        updateInfoResult: "none",
        errorMessage: null,
    },
};
var consumerState = /** @class */ (function (_super) {
    __extends(consumerState, _super);
    function consumerState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    consumerState.prototype.getConsumerData = function (clientId, accessToken) {
        this.draftState.loading = true;
    };
    consumerState.prototype.getConsumerFailure = function (errorMessage) {
        this.draftState.loading = false;
        this.draftState.errorMessage = errorMessage;
    };
    consumerState.prototype.getConsumerSuccess = function (consumer) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.data = consumer;
        this.draftState.errorMessage = null;
    };
    // Dans le cas ou saphir est fermé, la demande est en cours de traitement dans sapir donc on previent le client que la demande est en cours de traitement
    consumerState.prototype.updateConsumerPhoneNumberPendingTransmission = function () {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.errorMessage = null;
        this.draftState.updatePhoneNewsLetter.updateInfoResult = "pending";
    };
    consumerState.prototype.updateConsumerPhoneNumberAndNewsLetter = function (payload) {
        this.draftState.updatePhoneNewsLetter.loading = true;
    };
    consumerState.prototype.updateConsumerPhoneNumberAndNewsLetterFailure = function (errorMessage) {
        this.draftState.updatePhoneNewsLetter.loading = false;
        this.draftState.updatePhoneNewsLetter.errorMessage = errorMessage;
        this.draftState.updatePhoneNewsLetter.updateInfoResult = "failure";
    };
    consumerState.prototype.updateConsumerPhoneNumberAndNewsLetterSuccess = function () {
        this.draftState.updatePhoneNewsLetter.loading = false;
        this.draftState.updatePhoneNewsLetter.errorMessage = null;
        this.draftState.updatePhoneNewsLetter.updateInfoResult = "success";
    };
    consumerState.prototype.resetUpdateConsumerInfoResult = function () {
        this.draftState.updateInfoResult = "none";
    };
    consumerState.prototype.updateConsumerEmailNewsletter = function (payload) {
        this.draftState.loading = true;
    };
    consumerState.prototype.updateConsumerEmailNewsletterSuccess = function () {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.errorMessage = null;
        this.draftState.updateInfoResult = "success";
    };
    consumerState.prototype.updateConsumerEmailNewsletterFailure = function (errorMessage) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.errorMessage = errorMessage;
        this.draftState.updateInfoResult = "failure";
    };
    consumerState.prototype.updateConsumerSMSNewsletter = function (payload) {
        this.draftState.loading = true;
    };
    consumerState.prototype.updateConsumerSMSNewsletterSuccess = function () {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.errorMessage = null;
        this.draftState.updateInfoResult = 'success';
    };
    consumerState.prototype.updateConsumerSMSNewsletterFailure = function (errorMessage) {
        this.draftState.loading = false;
        this.draftState.loaded = true;
        this.draftState.errorMessage = errorMessage;
        this.draftState.updateInfoResult = 'failure';
    };
    consumerState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    return consumerState;
}(immer_reducer_1.ImmerReducer));
exports.consumerState = consumerState;
exports.consumerActions = (0, immer_reducer_1.createActionCreators)(consumerState);
exports.consumerReducerFunction = (0, immer_reducer_1.createReducerFunction)(consumerState, exports.initialState);
